var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigator",on:{"mouseenter":_vm.handleMousePresence,"mouseleave":_vm.handleMousePresence,"mousemove":_vm.handleMouseMove}},[_c('canvas',{ref:"canvas"}),(_vm.pointerVisible)?_c('div',{staticClass:"pointer block-color little-round",style:({ left: (_vm.pointerX + "px"), top: (_vm.pointerY + "px") })},[_c('div',{attrs:{"data-value":-this.points[this.activeXPoint]}},[_vm._v("X: ")]),_c('div',{attrs:{"data-value":this.points[this.activeYPoint]}},[_vm._v("Y: ")])]):_vm._e(),(_vm.pointerVisible && _vm.showAxises)?[_c('div',{staticClass:"line horizontal",style:({
        left: (_vm.horizontalLineX + "px"),
        top: (_vm.horizontalLineY + "px"),
        width: (_vm.horizontalLineWidth + "px")
      })}),_c('div',{staticClass:"line vertical",style:({
        left: (_vm.verticalLineX + "px"),
        top: (_vm.verticalLineY + "px"),
        height: (_vm.verticalLineHeight + "px")
      })})]:_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08873b38","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/UI/Grid/Navigator.vue
// module id = null
// module chunks = 